function createCustomEvents({ eventName, data }) {
    const event = new Event(eventName, data);
    document.dispatchEvent(event);
}

export { createCustomEvents };
//# sourceMappingURL=createCustomEvents.js.map
